import Swal from "sweetalert2";

export const successAlert = (title, text = "") =>
  Swal.fire({
    icon: "success",
    title,
    text,
    timer: 2000,
    showConfirmButton: false,
  });

export const errorAlert = (title, text = "") =>
  Swal.fire({
    icon: "error",
    title,
    text,
  });

export const warningAlert = (title, text = "") =>
  Swal.fire({
    icon: "warning",
    title,
    text,
  });

export const infoAlert = (title, text = "") =>
  Swal.fire({
    icon: "info",
    title,
    text,
  });

export const confirmAlert = ({
  title = "Are you sure?",
  text = "This action cannot be undone",
  confirmText = "Yes",
  cancelText = "Cancel",
}) =>
  Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
  });

const detectMessageKind = (rawMessage) => {
  const source = String(rawMessage || "").trim();
  if (!source) return { icon: "info", title: "Notice", text: "" };

  if (source.startsWith("✅")) {
    return { icon: "success", title: "Success", text: source.replace(/^✅\s*/, "") };
  }
  if (source.startsWith("❌")) {
    return { icon: "error", title: "Error", text: source.replace(/^❌\s*/, "") };
  }
  if (/^⚠️?/.test(source)) {
    return { icon: "warning", title: "Warning", text: source.replace(/^⚠️?\s*/, "") };
  }
  if (source.startsWith("⏳")) {
    return { icon: "info", title: "Please wait", text: source.replace(/^⏳\s*/, "") };
  }
  if (/^success\s*:/i.test(source)) {
    return { icon: "success", title: "Success", text: source.replace(/^success\s*:\s*/i, "") };
  }
  if (/^error\s*:/i.test(source) || /^failed\s*:/i.test(source)) {
    return {
      icon: "error",
      title: "Error",
      text: source.replace(/^(error|failed)\s*:\s*/i, ""),
    };
  }
  if (/^warning\s*:/i.test(source)) {
    return { icon: "warning", title: "Warning", text: source.replace(/^warning\s*:\s*/i, "") };
  }
  if (/^info\s*:/i.test(source)) {
    return { icon: "info", title: "Info", text: source.replace(/^info\s*:\s*/i, "") };
  }

  return { icon: "info", title: "Notice", text: source };
};

export const toastMessageAlert = (rawMessage, options = {}) => {
  const parsed = detectMessageKind(rawMessage);
  if (!parsed.text) return Promise.resolve();

  return Swal.fire({
    toast: true,
    position: options.position || "top-end",
    icon: options.icon || parsed.icon,
    title: options.title || parsed.title,
    text: options.text || parsed.text,
    timer: options.timer ?? 2200,
    showConfirmButton: false,
    timerProgressBar: true,
  });
};
